import React from "react";
import Profilepage from "../component/Profile/Profilepage";
import Navbar from "../component/Dasboard/Navbar";
import Dashboardsidenav from "../component/Dasboard/Dashboardsidenav";
import Heading from "../component/Dasboard/Heading";

const Profile = () => {
  return (
    <div className="md:h-[1100px] bg-[radial-gradient(89.62%_213.03%_at_38.75%_80.3%,_#07031C_0%,_#241D4A_30.52%,_#07031C_64.32%)]">
      <Navbar />
      <Heading />
      <div className="px-[10px] py-[10px] flex gap-6 ">
        <Dashboardsidenav />
        <Profilepage />
      </div>
    </div>
  );
};

export default Profile;
